import { Icon, IconName, Row, TextBody } from "../lib";
import { createStyles } from "../theme";

type Props = {
  icon: IconName;
  label: string;
};

export function PhotoBanner({ icon, label }: Props) {
  return (
    <Row.C style={$.container}>
      <Icon name={icon} color="onOverlay" />
      <TextBody em ml="2" color="onOverlay">
        {label}
      </TextBody>
    </Row.C>
  );
}

const $ = createStyles({
  container: {
    py: "2",
    backgroundColor: "overlay",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
});
